import './App.css';
import WeatherDate from './Weather';

function App() {
  return (
    <div className="App">
      <WeatherDate />
    </div>
  );
}

export default App;